import * as React from 'react';
import Nav from 'react-bootstrap/Nav';
import './styles.scss';

type TabType = {
  name: string;
  total: number;
};

interface Props {
  tabs: Array<TabType>;
  onSelect?: (eventKey: string) => void;
  selectedTab: string;
}

const TableTabs: React.FC<Props> = ({ tabs, onSelect, selectedTab }) => {
  return (
    <div className="table-main-navigation">
      <Nav
        as="ul"
        className="nav"
        onSelect={eventKey => onSelect(eventKey)}
        activeKey={selectedTab}
      >
        {tabs.map((item, index) => (
          <Nav.Item key={index} as="li" bsPrefix="navigation-item">
            <Nav.Link bsPrefix="navigation-link" eventKey={item.name}>
              {`${item.name} (${item.total})`}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    </div>
  );
};

export default TableTabs;
